'use client'

import { AppDispatch, RootState } from '@/app/globalRedux/store'
import { getCountryList } from '@/services/generalDataServices'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import RightAdsPanel from '../../../components/AdsFructidor/RightAdsPanel/RightAdsPanel'
import { EventPage } from './EventPage'

const EventMainPage = () => {
  const dispatch: AppDispatch = useDispatch()

  const countryList = useSelector(
    (state: RootState) => state.constantData.countriesList
  )

  useEffect(() => {
    if (countryList.length <= 0) {
      dispatch(getCountryList())
    }
  }, [])

  return (
    <div>
      <div className="flex justify-center mt-[30px] mobile:flex-col mobile:mt-[10px]">
        <div className="w-[1280px] flex justify-between mobile-width mobile:flex-col">
          <div className="mb-[30px]">
            <EventPage />
          </div>
          <RightAdsPanel />
        </div>
      </div>
    </div>
  )
}

export default EventMainPage
